import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import { globalTracker as tracker } from 'cogsworth/utils/Tracker'
import { graphQlErrorMessage } from 'cogsworth/utils/errorMessages'
import { requiresPayment } from 'cogsworth/utils/payments'
import { connect } from 'react-redux'

import bookAppointmentMutation from 'graphql/mutations/bookAppointment'
import rescheduleAppointmentMutation from 'graphql/mutations/rescheduleAppointment'
import { translate } from "react-i18next"
import compose from 'lodash/flowRight'

class SaveAppointment extends Component {
  constructor(props){
    super(props)

    this.state = {
      saving: false
    }

    this.create = this.create.bind(this)
    this.update = this.update.bind(this)
    this.canSave = this.canSave.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)
  }

  componentDidMount(){
    document.addEventListener("keyup", this.onKeyUp, false);
  }

  componentWillUnmount(){
    document.removeEventListener("keyup", this.onKeyUp, false);
  }

  onKeyUp(e){
    if(e.keyCode !== 13 || this.state.saving || e.target.id === "coupon-code") {
      return false
    }

    const handleSave = this.props.rescheduling ? this.update : this.create
    handleSave(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.booking && nextProps.booking.paymentId) {
      const handleSave = this.props.rescheduling ? this.update : this.create
      handleSave(nextProps)
    }
  }

  create(props) {
    if (this.state.saving) {
      return
    }

    const { booking } = props

    this.setState({ saving: true })

    props.bookAppointment({
      variables: {
        ...booking,
        requestUrl: window.location.href,
        isCustomTime: props.isCustomTime,
        requestTimeMessage: props.requestTimeMessage,
        couponCode: props.coupon,
      }
    }).then((response) => {
      const appointment = response.data.bookAppointment
      if( appointment ) {
        tracker.trackEvent('appointment create', 'administration', appointment.duration)
        tracker.trackGoogleAnalyticsEvent('Appointment booked', 'Cogsworth Booking Page')
        if (window.parent && window.parent.postMessage) {
          window.parent.postMessage({
            event: 'appointment-created',
          }, '*')
        } 
        props.onSave(appointment)
      }
    }).catch((error) => {
      this.setState({ saving: false })
      console.log(error)
      alert(graphQlErrorMessage(error))
    })
  }

  update(props) {
    if (this.state.saving) {
      return
    }

    const { booking, rescheduling } = props

    this.setState({ saving: true })

    const occurrenceDate = (!rescheduling.originalDate || new Date(rescheduling.originalDate).getTime() === 0) ? rescheduling.date : rescheduling.originalDate
    props.rescheduleAppointment({
      variables: {
        id: rescheduling.id,
        token: rescheduling.token,
        ...booking,
        rescheduleFutureOccurrences: props.rescheduleFutureOccurrences,
        occurrenceDate,
      }
    }).then((response) => {
      const appointment = response.data.rescheduleAppointment
      if( appointment ) {
        tracker.trackEvent('appointment edit', 'administration', appointment.duration)
        props.onSave(appointment)
      }
    }).catch((error) => {
      console.log(error.graphQLErrors)
      this.setState({ saving: false })
      console.log(error)
      alert(graphQlErrorMessage(error))
    })
  }

  canSave(){
    const { booking, fields } = this.props
    let canSave = true

    if(this.state.saving) return false

    // Check appointment fields
    if( !booking.duration || !booking.serviceId || !booking.date) {
      canSave = false
    }

    // TODO: Verify that payment has been approved, not just that it exists

    // Check required fields
    fields.filter(f => f.id.indexOf('booking_') === -1).forEach((field) => {
      if( field.required && (field.value === undefined || field.value === null || field.value === '') ) {
        canSave = false
      }
    })

    return canSave
  }

  getSaveButtonLabel() {
    const { t, rescheduling, booking, business } = this.props

    const templates = business.bookingTemplatesHtml


    const service = business.services.find(s => s.id === booking.serviceId)

    // Return "Request booking" label for bookings that require approval
    if (service.bookingsRequireApproval || this.props.isCustomTime) {
      return templates['request-booking-button'] || t('request-booking')
    }

    if (requiresPayment(service, booking.duration)) {
      return templates['pay-booking-button'] || 'press to pay for the appointment'
    }

    if (rescheduling) {
      return templates['confirm-booking-button'] || t('confirm-reschedule')
    }

    // Return "Confirm booking" label for regular bookings
    return templates['confirm-booking-button'] || t('confirm-booking')
  }

  render() {
    const canSave = this.canSave()
    const buttonLabel = this.getSaveButtonLabel()
    const handleSave = this.props.rescheduling ? () => { this.update(this.props) } : () => { this.create(this.props) }

    return (
      <div className="save">
        <button className="btn btn-primary" onClick={handleSave} disabled={!canSave} >
          <i className={ this.state.saving ? 'fa fa-gear fa-spin' : 'fa fa-check' }></i>&nbsp;&nbsp;<span dangerouslySetInnerHTML={{ __html: buttonLabel }} />
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isCustomTime: state.isCustomTime,
  requestTimeMessage: state.requestTimeMessage,
  coupon: state.coupon ? state.coupon.code : null,
})

export default translate("translations")(compose(
  graphql(bookAppointmentMutation, { name: 'bookAppointment' }),
  graphql(rescheduleAppointmentMutation, { name: 'rescheduleAppointment' })
)(connect(mapStateToProps)(SaveAppointment)))
